import React from "react";

const Table = ({ head, apiResponse, setApiResponse, activeResultTab }) => {
  console.log("apiResponse", apiResponse);
  return (
    <>
      <h1 className="text-[#037DFA] text-2xl font-bold">{head}</h1>
      <div className="parent py-10 rounded-3xl  mt-10 border h-[50vh] overflow-y-scroll	">
        <p className="px-5">
          All values are estimates based on the information provided.
        </p>
        <header className="sticky bg-slate-50 h-16 z-20 top-[-40px]  mt-7  rounded-t-lg text-white text-base border-gray-200">
          {/* <caption className="px-6 font-semibold w-96">{title}</caption> */}
          <div className="flex font-Poppins bg-[#0065cc]">
            <div className="w-1/3 text-white text-xl font-semibold px-6 py-3">
              Investor
            </div>
            <div className="w-1/3 text-white text-xl font-semibold px-6 py-3">
              Product
            </div>
            {/* <div className="w-1/3 px-6 py-3">Reasons</div> */}
          </div>
        </header>
        <div className=" relative overflow-x-auto  ">
          <div className="w-full text-sm text-left rtl:text-right text-gray-500">
            <div className="bg-blue-300 w-full">
              {apiResponse["Eligible products"].length === 0 && (
                <p className="bg-gray-50 text-black text-3xl font-semibold   text-center py-2">
                  No Eligable Product
                </p>
              )}
              {apiResponse["Eligible products"] &&
                (apiResponse["Eligible products"]).map(
                  (product, index) => {
                    console.log(apiResponse["Eligible products"]);
                    console.log(product)
                    return (
                      <div
                        key={index}
                        className={"odd:bg-white even:bg-slate-50 text-black"}
                      >
                        <div className="flex">
                          <div className="w-1/3 p-8 max-[600px]:p-4 font-medium text-gray-900 whitespace-nowrap">
                            Quantic Bank
                          </div>
                          <div className="w-1/3 p-8 max-[600px]:p-4 max-[600px]:w-[100%] cursor-pointer decoration-solid">
                            {product}
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Table;
